import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { itemActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const ItemsStyles = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const items = useSelector((state) => state.items);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Item Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "nick_name",
      headerName: "Item Nick Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
      hide: true,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
    {
      field: "weight",
      headerName: "Weight",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(itemActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {items && (
        <DataTable
          loading={items?.loading}
          rows={items?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="itemActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default ItemsStyles;
